import React from 'react';
import { Popover } from 'antd';
import SvgIcon from 'SvgIcon';

export default class FieldHelp extends React.Component {
	constructor(props) {
		super(props);
		const { cStyle } = props;
		let config = null;
		if (cStyle) {
			try {
				config = JSON.parse(cStyle);
			} catch (e) {
				config = {};
			}
		}
		//  let visible = false;
		if (config && config.text) {
			config.visible = true
		}
		this.state = Object.assign(
			{
				text: '',
				placement: 'bottom',
				maxWidth: '240px',
				maxHeight: '260px'
			},
			config
		);
	}
	componentDidMount() {
		if (this.props.model) this.props.model.addListener(this);
	}
	componentDidUpdate() {
		if (this.props.model) this.props.model.addListener(this);
	}
	componentWillUnmount() {
		if (this.props.model) this.props.model.removeListener(this);
	}
	getContent() {
		const { text, maxWidth, maxHeight,titlename } = this.state;
		let tipsList = [], tipsItem = [];
		if (typeof (text) != 'string' && Array.isArray(text)) {
      // let name = text[0];
      // text.splice(0,1)
      let tipsTitle = titlename ? <div className="tips_title">{titlename}</div> : null
			if(text.length == 1){
        tipsItem.push(<span className={"help_item"}>{text[0]}</span>)
        let item = (<div className="field_help1" style={{ 'max-width': maxWidth, 'max-height': maxHeight, overflowY: 'auto' }}>{tipsItem}</div>)
            tipsList.push(item)
      }
      else{
        text && text.forEach((ele, index) => {
          // let showText = '·'+ele
          tipsItem.push(<span className={"help_item"}>{ele}</span>)
          if(index % 2 == 1){
            let item = (<div className="field_help1" style={{ 'max-width': maxWidth, 'max-height': maxHeight, overflowY: 'auto' }}>{tipsItem}</div>)
            tipsList.push(item)
            tipsItem = []
          }
          else if (index == (text.length - 1)){
            let item = (<div className="field_help1" style={{ 'max-width': maxWidth, 'max-height': maxHeight, overflowY: 'auto' }}>{tipsItem}</div>)
            tipsList.push(item)
            tipsItem = []
          }
        })
      }
    return <div>{tipsTitle}{tipsList}</div>
		}
		else {
      tipsList.push(<div className="field_help1" style={{ 'max-width': maxWidth, 'max-height': maxHeight, overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: text }}></div>)
      return tipsList;
		}

	}

	render() {
		const { placement, visible } = this.state;
		let style = visible ? {} : { display: 'none' }
		let content = this.getContent();
		return (
			<Popover content={content} trigger="hover" placement={placement} arrowPointAtCenter>
				<i className="anticon anticon-bangzhuzhongxin" style={style} ></i>
			</Popover>
		);
	}
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/fieldHelp.jsx